const abc = [
  {
    Title: "Avatar",
    Year: "2009",
    rated: "PG-13",
    released: "18 Dec 2009",
    Runtime: "162 min",
    Genre: "Action, Adventure, Fantasy",
    Director: "James Cameron",
    Writer: "James Cameron",
    Actors: "Sam Worthington, Zoe Saldana, Sigourney Weaver, Stephen Lang",
    Plot: "A paraplegic marine dispatched to the moon Pandora on a unique mission becomes torn between following his orders and protecting the world he feels is his home.",
    Language: "English, Spanish",
    Country: "USA, UK",
    Awards: "Won 3 Oscars. Another 80 wins & 121 nominations.",
    poster:
      "https://posters.movieposterdb.com/23_01/2009/499549/l_avatar-movie-poster_c111a145.png",
    Metascore: "83",
    imdbRating: "7.9",
    imdbVotes: "890,617",
    imdbID: "tt0499549",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/9548/1369548-t-4a605a90e6ca",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjEyOTYyMzUxNl5BMl5BanBnXkFtZTcwNTg0MTUzNA@@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzM2MDk3MTcyMV5BMl5BanBnXkFtZTcwNjg0MTUzNA@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTY2ODQ3NjMyMl5BMl5BanBnXkFtZTcwODg0MTUzNA@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTMxOTEwNDcxN15BMl5BanBnXkFtZTcwOTg0MTUzNA@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYxMDg1Nzk1MV5BMl5BanBnXkFtZTcwMDk0MTUzNA@@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
    ],
  },
  {
    Title: "I Am Legend",
    Year: "2007",
    rated: "PG-13",
    released: "14 Dec 2007",
    Runtime: "101 min",
    Genre: "Drama, Horror, Sci-Fi",
    Director: "Francis Lawrence",
    Writer:
      "Mark Protosevich (screenplay), Akiva Goldsman (screenplay), Richard Matheson (novel), John William Corrington, Joyce Hooper Corrington",
    Actors:
      "Will Smith, Alice Braga, Charlie Tahan, Salli Richardson-Whitfield",
    Plot: "Years after a plague kills most of humanity and transforms the rest into monsters, the sole survivor in New York City struggles valiantly to find a cure.",
    Language: "English",
    Country: "USA",
    Awards: "9 wins & 21 nominations.",
    poster:
      "https://posters.movieposterdb.com/07_12/2007/480249/s_480249_66680d6b.jpg",
    Metascore: "65",
    imdbRating: "7.2",
    imdbVotes: "533,874",
    imdbID: "tt0480249",
    Type: "movie",
    Response: "True",
    images: [
      "https://s29288.pcdn.co/wp-content/uploads/2020/08/i-am-legend-image-750.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTI0NTI4NjE3NV5BMl5BanBnXkFtZTYwMDA0Nzc4._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTIwMDg2MDU4M15BMl5BanBnXkFtZTYwMTA0Nzc4._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc5MDM1OTU5OV5BMl5BanBnXkFtZTYwMjA0Nzc4._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTA0MTI2NjMzMzFeQTJeQWpwZ15BbWU2MDMwNDc3OA@@._V1_.jpg",
    ],
  },
  {
    Title: "300",
    Year: "2006",
    rated: "R",
    released: "09 Mar 2007",
    Runtime: "117 min",
    Genre: "Action, Drama, Fantasy",
    Director: "Zack Snyder",
    Writer:
      "Zack Snyder (screenplay), Kurt Johnstad (screenplay), Michael Gordon (screenplay), Frank Miller (graphic novel), Lynn Varley (graphic novel)",
    Actors: "Gerard Butler, Lena Headey, Dominic West, David Wenham",
    Plot: "King Leonidas of Sparta and a force of 300 men fight the Persians at Thermopylae in 480 B.C.",
    Language: "English",
    Country: "USA",
    Awards: "16 wins & 42 nominations.",
    poster:
      "https://posters.movieposterdb.com/07_09/2006/0416449/l_0416449_ebba784f.jpg",
    Metascore: "52",
    imdbRating: "7.7",
    imdbVotes: "611,046",
    imdbID: "tt0416449",
    Type: "movie",
    Response: "True",
    images: [
      "https://ntvb.tmsimg.com/assets/p9497161_v_h10_ac.jpg?w=1280&h=720",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTMwNTg5MzMwMV5BMl5BanBnXkFtZTcwMzA2NTIyMw@@._V1_SX1777_CR0,0,1777,937_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQwNTgyNTMzNF5BMl5BanBnXkFtZTcwNDA2NTIyMw@@._V1_SX1777_CR0,0,1777,935_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc0MjQzOTEwMV5BMl5BanBnXkFtZTcwMzE2NTIyMw@@._V1_SX1777_CR0,0,1777,947_AL_.jpg",
    ],
  },
  {
    Title: "The Avengers",
    Year: "2012",
    rated: "PG-13",
    released: "04 May 2012",
    Runtime: "143 min",
    Genre: "Action, Sci-Fi, Thriller",
    Director: "Joss Whedon",
    Writer: "Joss Whedon (screenplay), Zak Penn (story), Joss Whedon (story)",
    Actors: "Robert Downey Jr., Chris Evans, Mark Ruffalo, Chris Hemsworth",
    Plot: "Earth's mightiest heroes must come together and learn to fight as a team if they are to stop the mischievous Loki and his alien army from enslaving humanity.",
    Language: "English, Russian",
    Country: "USA",
    Awards: "Nominated for 1 Oscar. Another 34 wins & 75 nominations.",
    poster:
      "https://posters.movieposterdb.com/12_01/2012/848228/l_848228_df20a875.jpg",
    Metascore: "69",
    imdbRating: "8.1",
    imdbVotes: "1,003,301",
    imdbID: "tt0848228",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/52/1370052-t-c192aeeb4c31",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTA0NjY0NzE4OTReQTJeQWpwZ15BbWU3MDczODg2Nzc@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE1MzEzMjcyM15BMl5BanBnXkFtZTcwNDM4ODY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMwMzM2MTg1M15BMl5BanBnXkFtZTcwNjM4ODY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ4NzM2Mjc5MV5BMl5BanBnXkFtZTcwMTkwOTY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc3MzQ3NjA5N15BMl5BanBnXkFtZTcwMzY5OTY3Nw@@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
    ],
  },
  {
    Title: "The Wolf of Wall Street",
    Year: "2013",
    rated: "R",
    released: "25 Dec 2013",
    Runtime: "180 min",
    Genre: "Biography, Comedy, Crime",
    Director: "Martin Scorsese",
    Writer: "Terence Winter (screenplay), Jordan Belfort (book)",
    Actors: "Leonardo DiCaprio, Jonah Hill, Margot Robbie, Matthew McConaughey",
    Plot: "Based on the true story of Jordan Belfort, from his rise to a wealthy stock-broker living the high life to his fall involving crime, corruption and the federal government.",
    Language: "English, French",
    Country: "USA",
    Awards: "Nominated for 5 Oscars. Another 35 wins & 154 nominations.",
    poster:
      "https://posters.movieposterdb.com/13_11/2013/993846/l_993846_6b55e2ea.jpg",
    Metascore: "75",
    imdbRating: "8.2",
    imdbVotes: "786,985",
    imdbID: "tt0993846",
    Type: "movie",
    Response: "True",
    images: [
      "https://wallpaperaccess.com/full/1306888.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDIwMDIxNzk3Ml5BMl5BanBnXkFtZTgwMTg0MzQ4MDE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc0NzAxODAyMl5BMl5BanBnXkFtZTgwMDg0MzQ4MDE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTExMDk1MDE4NzVeQTJeQWpwZ15BbWU4MDM4NDM0ODAx._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTg3MTY4NDk4Nl5BMl5BanBnXkFtZTgwNjc0MzQ4MDE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgzMTg4MDI0Ml5BMl5BanBnXkFtZTgwOTY0MzQ4MDE@._V1_SY1000_CR0,0,1553,1000_AL_.jpg",
    ],
  },
  {
    Title: "Interstellar",
    Year: "2014",
    rated: "PG-13",
    released: "07 Nov 2014",
    Runtime: "169 min",
    Genre: "Adventure, Drama, Sci-Fi",
    Director: "Christopher Nolan",
    Writer: "Jonathan Nolan, Christopher Nolan",
    Actors: "Ellen Burstyn, Matthew McConaughey, Mackenzie Foy, John Lithgow",
    Plot: "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.",
    Language: "English",
    Country: "USA, UK",
    Awards: "Won 1 Oscar. Another 39 wins & 134 nominations.",
    poster:
      "https://posters.movieposterdb.com/15_03/2014/816692/l_816692_284eb9d5.jpg",
    Metascore: "74",
    imdbRating: "8.6",
    imdbVotes: "937,412",
    imdbID: "tt0816692",
    Type: "movie",
    Response: "True",
    images: [
      "https://wallpapercave.com/dwp1x/wp1818001.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA3NTEwOTMxMV5BMl5BanBnXkFtZTgwMjMyODgxMzE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMzQ5ODE2MzEwM15BMl5BanBnXkFtZTgwMTMyODgxMzE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTg4Njk4MzY0Nl5BMl5BanBnXkFtZTgwMzIyODgxMzE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMzE3MTM0MTc3Ml5BMl5BanBnXkFtZTgwMDIyODgxMzE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjYzNjE2NDk3N15BMl5BanBnXkFtZTgwNzEyODgxMzE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
    ],
  },
  {
    Title: "Game of Thrones",
    Year: "2011–",
    rated: "TV-MA",
    released: "17 Apr 2011",
    Runtime: "56 min",
    Genre: "Adventure, Drama, Fantasy",
    Director: "N/A",
    Writer: "David Benioff, D.B. Weiss",
    Actors: "Peter Dinklage, Lena Headey, Emilia Clarke, Kit Harington",
    Plot: "While a civil war brews between several noble families in Westeros, the children of the former rulers of the land attempt to rise up to power. Meanwhile a forgotten race, bent on destruction, plans to return after thousands of years in the North.",
    Language: "English",
    Country: "USA, UK",
    Awards: "Won 1 Golden Globe. Another 185 wins & 334 nominations.",
    poster:
      "https://posters.movieposterdb.com/11_03/2011/944947/l_944947_390180e8.jpg",
    Metascore: "N/A",
    imdbRating: "9.5",
    imdbVotes: "1,046,830",
    imdbID: "tt0944947",
    Type: "series",
    totalSeasons: "7",
    Response: "True",
    images: [
      "https://p4.wallpaperbetter.com/wallpaper/266/71/697/game-of-thrones-wallpaper-preview.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDc1MGUyNzItNWRkOC00MjM1LWJjNjMtZTZlYWIxMGRmYzVlXkEyXkFqcGdeQXVyMzU3MDEyNjk@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZjZkN2M5ODgtMjQ2OC00ZjAxLWE1MjMtZDE0OTNmNGM0NWEwXkEyXkFqcGdeQXVyNjUxNzgwNTE@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMDk4Y2Y1MDAtNGVmMC00ZTlhLTlmMmQtYjcyN2VkNzUzZjg2XkEyXkFqcGdeQXVyNjUxNzgwNTE@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjZjNWIzMzQtZWZjYy00ZTkwLWJiMTYtOWRkZDBhNWJhY2JmXkEyXkFqcGdeQXVyMjk3NTUyOTc@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNTMyMTRjZWEtM2UxMS00ZjU5LWIxMTYtZDA5YmJhZmRjYTc4XkEyXkFqcGdeQXVyMjk3NTUyOTc@._V1_SX1777_CR0,0,1777,999_AL_.jpg",
    ],
  },
  {
    Title: "Vikings",
    Year: "2013–",
    rated: "TV-14",
    released: "03 Mar 2013",
    Runtime: "44 min",
    Genre: "Action, Drama, History",
    Director: "N/A",
    Writer: "Michael Hirst",
    Actors: "Travis Fimmel, Clive Standen, Gustaf Skarsgård, Katheryn Winnick",
    Plot: "The world of the Vikings is brought to life through the journey of Ragnar Lothbrok, the first Viking to emerge from Norse legend and onto the pages of history - a man on the edge of myth.",
    Language: "English, Old English, Norse, Old, Latin",
    Country: "Ireland, Canada",
    Awards:
      "Nominated for 7 Primetime Emmys. Another 17 wins & 49 nominations.",
    poster:
      "https://posters.movieposterdb.com/13_07/2013/2306299/l_2306299_e4d03de6.jpg",
    Metascore: "N/A",
    imdbRating: "8.6",
    imdbVotes: "198,041",
    imdbID: "tt2306299",
    Type: "series",
    totalSeasons: "5",
    Response: "True",
    images: [
      "https://occ-0-3752-2186.1.nflxso.net/dnm/api/v6/LmEnxtiAuzezXBjYXPuDgfZ4zZQ/AAAABQ-ZQ3oPc7b85jC6RlYHta0VDciPakkztJ02ojxodAUyFcqA-IlJu8S7qnMSzJSAI9ACorl6WFfAgdtey5bwa9zkb9Y2RKkZdlPzVcmYj1bx.png?r=896",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjM5MTM1ODUxNV5BMl5BanBnXkFtZTgwNTAzOTI2ODE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNzU2NDcxODMyOF5BMl5BanBnXkFtZTgwNDAzOTI2ODE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMzMzIzOTU2M15BMl5BanBnXkFtZTgwODMzMTkyODE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ2NTQ2MDA3NF5BMl5BanBnXkFtZTgwODkxMDUxODE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTcxOTQ3NTA5N15BMl5BanBnXkFtZTgwMzExMDUxODE@._V1_SY1000_SX1500_AL_.jpg",
    ],
  },
  {
    Title: "Power",
    Year: "2014–",
    rated: "TV-MA",
    released: "N/A",
    Runtime: "50 min",
    Genre: "Crime, Drama",
    Director: "N/A",
    Writer: "Courtney Kemp Agboh",
    Actors: "Omari Hardwick, Joseph Sikora, Andy Bean, Lela Loren",
    Plot: 'James "Ghost" St. Patrick, a wealthy New York night club owner who has it all, catering for the city\'s elite and dreaming big, lives a double life as a drug kingpin.',
    Language: "English",
    Country: "USA",
    Awards: "1 win & 6 nominations.",
    poster:
      "https://posters.movieposterdb.com/15_04/2014/3281796/s_3281796_4e085046.jpg",
    Metascore: "N/A",
    imdbRating: "8.0",
    imdbVotes: "14,770",
    imdbID: "tt3281796",
    Type: "series",
    totalSeasons: "3",
    Response: "True",
    images: [
      "https://img.airtel.tv/unsafe/fit-in/900x0/filters:format(webp)/https://xstreamcp-assets-msp.streamready.in/assets/LIONSGATEPLAY/SERIES/6492bfcc5f85c677750e9159/images/POWERY2014S01E001-lgi-landscape-poster-1920X1080-PSTL.jpg?o=production",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTc2ODg0MzMzM15BMl5BanBnXkFtZTgwODYxODA5NTE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTcyMjA0MzczNV5BMl5BanBnXkFtZTgwNTIyODA5NTE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTk0MTI0NzQ2NV5BMl5BanBnXkFtZTgwMDkxODA5NTE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ4Mzk1ODcxM15BMl5BanBnXkFtZTgwNDQyODA5NTE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTUwNTE0NDI1M15BMl5BanBnXkFtZTgwMDQyODA5NTE@._V1_SY1000_SX1500_AL_.jpg",
    ],
  },
  {
    Title: "Narcos",
    Year: "2015–",
    rated: "TV-MA",
    released: "28 Aug 2015",
    Runtime: "49 min",
    Genre: "Biography, Crime, Drama",
    Director: "N/A",
    Writer: "Carlo Bernard, Chris Brancato, Doug Miro, Paul Eckstein",
    Actors: "Wagner Moura, Boyd Holbrook, Pedro Pascal, Joanna Christie",
    Plot: "A chronicled look at the criminal exploits of Colombian drug lord Pablo Escobar.",
    Language: "English, Spanish",
    Country: "USA",
    Awards: "Nominated for 2 Golden Globes. Another 4 nominations.",
    poster:
      "https://posters.movieposterdb.com/15_09/2015/2707408/l_2707408_45242cce.jpg",
    Metascore: "N/A",
    imdbRating: "8.9",
    imdbVotes: "118,680",
    imdbID: "tt2707408",
    Type: "series",
    totalSeasons: "2",
    Response: "True",
    images: [
      "https://occ-0-3752-2186.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABSfH7g95oOQujxJKmNM2hMXTo4igNawjofOgvL86rdCI2TnL4-QhYcfpsaHjLAnblKpAh_8w2zXVkhpIgD9WOtvVMRyFXKaPwWFamX4u6yHpJobknNxFBe5yWAdpjiepTYOPTuazy-1Tow8VWgpMEv-eJRsbL-dLhm3OSTmwKWWfK88pHWXAzA.png?r=de0",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTk2MDMzMTc0MF5BMl5BanBnXkFtZTgwMTAyMzA1OTE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjIxMDkyOTEyNV5BMl5BanBnXkFtZTgwNjY3Mjc3OTE@._V1_SY1000_SX1500_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA2NDUwMTU2NV5BMl5BanBnXkFtZTgwNTI1Mzc3OTE@._V1_SY1000_CR0,0,1499,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BODA1NjAyMTQ3Ml5BMl5BanBnXkFtZTgwNjI1Mzc3OTE@._V1_SY1000_CR0,0,1499,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTU0NzQ0OTAwNl5BMl5BanBnXkFtZTgwMDAyMzA1OTE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
    ],
  },
  {
    Title: "Breaking Bad",
    Year: "2008–2013",
    rated: "TV-14",
    released: "20 Jan 2008",
    Runtime: "49 min",
    Genre: "Crime, Drama, Thriller",
    Director: "N/A",
    Writer: "Vince Gilligan",
    Actors: "Bryan Cranston, Anna Gunn, Aaron Paul, Dean Norris",
    Plot: "A high school chemistry teacher diagnosed with inoperable lung cancer turns to manufacturing and selling methamphetamine in order to secure his family's financial future.",
    Language: "English, Spanish",
    Country: "USA",
    Awards: "Won 2 Golden Globes. Another 132 wins & 218 nominations.",
    poster:
      "https://posters.movieposterdb.com/08_04/2008/903747/l_903747_a1327335.jpg",
    Metascore: "N/A",
    imdbRating: "9.5",
    imdbVotes: "889,883",
    imdbID: "tt0903747",
    Type: "series",
    totalSeasons: "5",
    Response: "True",
    images: [
      "https://occ-0-3752-2186.1.nflxso.net/dnm/api/v6/LmEnxtiAuzezXBjYXPuDgfZ4zZQ/AAAABeJo_eP3qXqDWnaRWhbGbLu1VN_yACCncu6G7-CW4pCSzZD74lWxcVvYw4koEFN9bmO2PERuTLR7KiXVURG1MSTFXlS9GTB0selwbgbCBtTR.png?r=295",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgyMzI5NDc5Nl5BMl5BanBnXkFtZTgwMjM0MTI2MDE@._V1_SY1000_CR0,0,1498,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTQ2NDkwNDk5NV5BMl5BanBnXkFtZTgwNDM0MTI2MDE@._V1_SY1000_CR0,0,1495,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTM4NDcyNDMzMF5BMl5BanBnXkFtZTgwOTI0MTI2MDE@._V1_SY1000_CR0,0,1495,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTAzMTczMjM3NjFeQTJeQWpwZ15BbWU4MDc1MTI1MzAx._V1_SY1000_CR0,0,1495,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjA5MTE3MTgwMF5BMl5BanBnXkFtZTgwOTQxMjUzMDE@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
    ],
  },
  {
    ComingSoon: true,
    Title: "Doctor Strange",
    Year: "2016",
    rated: "N/A",
    released: "04 Nov 2016",
    Runtime: "N/A",
    Genre: "Action, Adventure, Fantasy",
    Director: "Scott Derrickson",
    Writer:
      "Scott Derrickson (screenplay), C. Robert Cargill (screenplay), Jon Spaihts (story by), Scott Derrickson (story by), C. Robert Cargill (story by), Steve Ditko (comic book)",
    Actors:
      "Rachel McAdams, Benedict Cumberbatch, Mads Mikkelsen, Tilda Swinton",
    Plot: "After his career is destroyed, a brilliant but arrogant and conceited surgeon gets a new lease on life when a sorcerer takes him under her wing and trains him to defend the world against evil.",
    Language: "English",
    Country: "USA",
    Awards: "N/A",
    poster:
      "https://posters.movieposterdb.com/20_08/2013/1211837/l_1211837_b473cc46.jpg",
    Metascore: "N/A",
    imdbRating: "N/A",
    imdbVotes: "N/A",
    imdbID: "tt1211837",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/1175/1371175-t-00259386fecd",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjM3ODc1ODI5Ml5BMl5BanBnXkFtZTgwODMzMDY3OTE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgxNTAyNTU0NV5BMl5BanBnXkFtZTgwNzMzMDY3OTE@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE5NDc5NzUwNV5BMl5BanBnXkFtZTgwMDM3MDM2NzE@._V1_.jpg",
    ],
  },
  {
    ComingSoon: true,
    Title: "Rogue One: A Star Wars Story",
    Year: "2016",
    rated: "N/A",
    released: "16 Dec 2016",
    Runtime: "N/A",
    Genre: "Action, Adventure, Sci-Fi",
    Director: "Gareth Edwards",
    Writer:
      "Chris Weitz (screenplay), Tony Gilroy (screenplay), John Knoll (story), Gary Whitta (story), George Lucas (characters)",
    Actors: "Felicity Jones, Riz Ahmed, Mads Mikkelsen, Ben Mendelsohn",
    Plot: "The Rebellion makes a risky move to steal the plans to the Death Star, setting up the epic saga to follow.",
    Language: "English",
    Country: "USA",
    Awards: "1 nomination.",
    poster:
      "https://posters.movieposterdb.com/21_03/2016/3748528/l_3748528_65f0feb0.jpg",
    Metascore: "N/A",
    imdbRating: "N/A",
    imdbVotes: "N/A",
    imdbID: "tt3748528",
    Type: "movie",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/8789/1368789-t-84e9011347e0",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE3MzA4Nzk3NV5BMl5BanBnXkFtZTgwNjAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNDMxMTQzMjQxM15BMl5BanBnXkFtZTgwNzAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTUyNjkxOTk5NV5BMl5BanBnXkFtZTgwODAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BNjM4MzExNDAyNl5BMl5BanBnXkFtZTgwOTAxMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjE3NTgxMDcyNV5BMl5BanBnXkFtZTgwMDExMTc1ODE@._V1_SX1777_CR0,0,1777,744_AL_.jpg",
    ],
  },
  {
    ComingSoon: true,
    Title: "Assassin's Creed",
    Year: "2016",
    rated: "N/A",
    released: "21 Dec 2016",
    Runtime: "N/A",
    Genre: "Action, Adventure, Fantasy",
    Director: "Justin Kurzel",
    Writer:
      "Bill Collage (screenplay), Adam Cooper (screenplay), Michael Lesslie (screenplay)",
    Actors:
      "Michael Fassbender, Michael Kenneth Williams, Marion Cotillard, Jeremy Irons",
    Plot: "When Callum Lynch explores the memories of his ancestor Aguilar and gains the skills of a Master Assassin, he discovers he is a descendant of the secret Assassins society.",
    Language: "English",
    Country: "UK, France, USA, Hong Kong",
    Awards: "N/A",
    poster:
      "https://posters.movieposterdb.com/21_04/2015/2094766/l_2094766_82f32f03.jpg",
    Metascore: "N/A",
    imdbRating: "N/A",
    imdbVotes: "N/A",
    imdbID: "tt2094766",
    Type: "movie",
    Response: "True",
    images: [
      "https://cdn.europosters.eu/image/hp/71085.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BN2EyYzgyOWEtNTY2NS00NjRjLWJiNDYtMWViMjg5MWZjYjgzXkEyXkFqcGdeQXVyNjUwNzk3NDc@._V1_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTYwOWYzOTctOTc4My00ZmJkLTgzMTctMmUxNDI5ODQzYzNjXkEyXkFqcGdeQXVyNDAyODU1Njc@._V1_SX1500_CR0,0,1500,999_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZTY5ZGUxMTAtYTU0OC00NGQ2LTkzNzgtZGZmNjlmNjY3MGU0XkEyXkFqcGdeQXVyNTY0MTkxMTg@._V1_SY1000_CR0,0,1500,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BZjA0MWYwZTEtYzc5Yi00NGM2LTg1YTctNjY2YzQ0NDJhZDAwXkEyXkFqcGdeQXVyNDAyODU1Njc@._V1_SY1000_CR0,0,1499,1000_AL_.jpg",
    ],
  },
  {
    ComingSoon: true,
    Title: "Luke Cage",
    Year: "2016–",
    rated: "TV-MA",
    released: "30 Sep 2016",
    Runtime: "55 min",
    Genre: "Action, Crime, Drama",
    Director: "N/A",
    Writer: "Cheo Hodari Coker",
    Actors: "Mahershala Ali, Mike Colter, Frankie Faison, Erik LaRay Harvey",
    Plot: "Given superstrength and durability by a sabotaged experiment, a wrongly accused man escapes prison to become a superhero for hire.",
    Language: "English",
    Country: "USA",
    Awards: "N/A",
    poster:
      "https://posters.movieposterdb.com/22_08/2016/3322314/l_3322314_668afee7.jpg",
    Metascore: "N/A",
    imdbRating: "N/A",
    imdbVotes: "N/A",
    imdbID: "tt3322314",
    Type: "series",
    totalSeasons: "1",
    Response: "True",
    images: [
      "https://img1.hotstarext.com/image/upload/f_auto,h_136/sources/r1/cms/prod/9761/1379761-t-9a429891a8c7",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMxNjc1NjI0NV5BMl5BanBnXkFtZTgwNzA0NzY0ODE@._V1_SY1000_CR0,0,1497,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjI1MDg3NjY2OF5BMl5BanBnXkFtZTgwNDE1NDU4OTE@._V1_SY1000_CR0,0,1497,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BOTYzOTQyNDYxNl5BMl5BanBnXkFtZTgwNzA1NDU4OTE@._V1_SY1000_CR0,0,1498,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMTgxMjA3MTQ5Ml5BMl5BanBnXkFtZTgwOTA1NDU4OTE@._V1_SY1000_CR0,0,1498,1000_AL_.jpg",
      "https://images-na.ssl-images-amazon.com/images/M/MV5BMjMyNjg5ODYwNF5BMl5BanBnXkFtZTgwMTE1NDU4OTE@._V1_SY1000_CR0,0,1477,1000_AL_.jpg",
    ],
  },
];

export default abc;
